/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M0 3C0 1.7574 1.0074.75 2.25.75h19.5C22.9926.75 24 1.7574 24 3v12c0 1.2426-1.0074 2.25-2.25 2.25H2.25C1.0074 17.25 0 16.2426 0 15V3Zm2.25-.75A.75.75 0 0 0 1.5 3v12a.75.75 0 0 0 .75.75h19.5a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75H2.25Zm0 18.75a.75.75 0 0 0 0 1.5h19.5a.75.75 0 0 0 0-1.5H2.25Z"
    clipRule="evenodd"
  />,
  'SubOverview'
);
